module.exports = __webpack_public_path__ + "static/texture-885ca295b1e087c6f2a445dbff821323.gif";